module.exports = __webpack_public_path__ + "static/social-share-ce66ae2d94a78be509400cb4c79ebc68.jpg";